import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Subaward T&C Monitoring Activity Assignment: The association(s) of term/condition and monitoring activity. Typically used to automatically apply monitoring activities based on the specified terms and conditions.',
    name: 'Subaward T&C Monitoring Activity Associations',
    partialId: PartialId.Standard.create('subaward_tc_monitor_act'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
